import { render, staticRenderFns } from "./related-products.vue?vue&type=template&id=5351da6d&scoped=true&"
import script from "./related-products.vue?vue&type=script&lang=js&"
export * from "./related-products.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5351da6d",
  null
  
)

export default component.exports